import { create } from 'zustand'

interface AuthState {
  state: 'login' | 'otp'
  email: string
  user: number
  otp: string
  phone_number: string
  setState: (state: 'login' | 'otp') => void
  setEmail: (email: string) => void
  setUser: (user: number) => void
  setOtp: (otp: string) => void
  setPhoneNumber: (phone_number: string) => void
  reset: () => void
}

const useAuthStore = create<AuthState>((set) => ({
  state: 'login',
  email: '',
  user: 0,
  otp: '',
  phone_number: '',
  setState: (state) => set(() => ({ state: state })),
  setEmail: (email) => set({ email }),
  setUser: (user) => set({ user }),
  setOtp: (otp) => set({ otp }),
  setPhoneNumber: (phone_number) => set({ phone_number }),
  reset: () => set({ email: '', user: 0, otp: '' }),
}))

export default useAuthStore
